"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CookieBanner = /*#__PURE__*/function (_Component) {
  function CookieBanner(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CookieBanner);
    _this = _callSuper(this, CookieBanner, [props]);
    var showBanner = false;
    if (_jsCookie["default"].get('hid_cookie_banner') === undefined) {
      showBanner = true;
      _jsCookie["default"].set('hid_cookie_banner', true, {
        expires: 365
      });
    }
    _this.state = {
      showBanner: showBanner
    };
    _this.hideBanner = _this.hideBanner.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CookieBanner, _Component);
  return (0, _createClass2["default"])(CookieBanner, [{
    key: "hideBanner",
    value: function hideBanner() {
      this.setState({
        showBanner: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var privacyPolicyUrl = this.props.privacyPolicyUrl;
      var showBanner = this.state.showBanner;
      if (!showBanner) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cookie-banner alert alert-info relative white"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "tac",
        style: {
          margin: '0 auto'
        }
      }, "Our website uses cookies. 'Cause they're delish.\xA0", /*#__PURE__*/_react["default"].createElement("a", {
        href: privacyPolicyUrl,
        rel: "nofollow",
        title: "Privacy & Cookies Policy",
        style: {
          color: '#fff'
        }
      }, "Read more")), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "close",
        onClick: this.hideBanner
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Close")));
    }
  }]);
}(_react.Component);
CookieBanner.propTypes = {
  privacyPolicyUrl: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = CookieBanner;